<template>
  <footer class="footer">
    <div class="columns is-mobile is-vcentered has-text-centered">
      <div class="column">
        <p>
          Powered by <a href="http://updivision.com/">UPDIVISION</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
};
</script>
